const DEFINITION_ITEM_KEY = {
  caption: 'caption',
  link: 'link',
  summary: 'summary',
}

export default DEFINITION_ITEM_KEY;
